import { render, staticRenderFns } from "./PersonalDataAgreementComponent.vue?vue&type=template&id=0a75bb49&"
import script from "./PersonalDataAgreementComponent.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataAgreementComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports